export default {
    getApiCache: (state) => (key) => {
        if (typeof (state.api_cache[key]) === "undefined") {
            return false
        }
        return state.api_cache[key]
    },
}
